export const isMobileView = () => window.innerWidth < 800;
